export default __webpack_public_path__ + "static/media/mtb.a5f5dbb2.svg";